export const HELP_CENTER_SECTIONS = [
  {
    id: "dashboard",
    titleKey: "helpCenter.dashboard.title",
    overviewKey: "helpCenter.dashboard.overview",
    featureKeys: [
      "helpCenter.dashboard.feature1",
      "helpCenter.dashboard.feature2",
      "helpCenter.dashboard.feature3",
      "helpCenter.dashboard.feature4"
    ],
    stepKeys: [
      "helpCenter.dashboard.step1",
      "helpCenter.dashboard.step2",
      "helpCenter.dashboard.step3"
    ],
    noteKeys: ["helpCenter.dashboard.note1"],
    path: "/home"
  },
  {
    id: "profile",
    titleKey: "helpCenter.profile.title",
    overviewKey: "helpCenter.profile.overview",
    featureKeys: [
      "helpCenter.profile.feature1",
      "helpCenter.profile.feature2",
      "helpCenter.profile.feature3"
    ],
    stepKeys: [
      "helpCenter.profile.step1",
      "helpCenter.profile.step2",
      "helpCenter.profile.step3",
      "helpCenter.profile.step4"
    ],
    noteKeys: ["helpCenter.profile.note1", "helpCenter.profile.note2"],
    path: "/profile"
  },
  {
    id: "engine-config",
    titleKey: "helpCenter.engineConfig.title",
    overviewKey: "helpCenter.engineConfig.overview",
    featureKeys: [
      "helpCenter.engineConfig.feature1",
      "helpCenter.engineConfig.feature2",
      "helpCenter.engineConfig.feature3",
      "helpCenter.engineConfig.feature4"
    ],
    stepKeys: [
      "helpCenter.engineConfig.step1",
      "helpCenter.engineConfig.step2",
      "helpCenter.engineConfig.step3",
      "helpCenter.engineConfig.step4",
      "helpCenter.engineConfig.step5"
    ],
    noteKeys: ["helpCenter.engineConfig.note1", "helpCenter.engineConfig.note2"],
    path: "/engine-config"
  },
  {
    id: "api-generator",
    titleKey: "helpCenter.apiGenerator.title",
    overviewKey: "helpCenter.apiGenerator.overview",
    featureKeys: [
      "helpCenter.apiGenerator.feature1",
      "helpCenter.apiGenerator.feature2",
      "helpCenter.apiGenerator.feature3",
      "helpCenter.apiGenerator.feature4",
      "helpCenter.apiGenerator.feature5"
    ],
    stepKeys: [
      "helpCenter.apiGenerator.step1",
      "helpCenter.apiGenerator.step2",
      "helpCenter.apiGenerator.step3",
      "helpCenter.apiGenerator.step4",
      "helpCenter.apiGenerator.step5",
      "helpCenter.apiGenerator.step6"
    ],
    noteKeys: ["helpCenter.apiGenerator.note1", "helpCenter.apiGenerator.note2"],
    path: "/api-generator"
  },
  {
    id: "my-apis",
    titleKey: "helpCenter.myApis.title",
    overviewKey: "helpCenter.myApis.overview",
    featureKeys: [
      "helpCenter.myApis.feature1",
      "helpCenter.myApis.feature2",
      "helpCenter.myApis.feature3",
      "helpCenter.myApis.feature4"
    ],
    stepKeys: [
      "helpCenter.myApis.step1",
      "helpCenter.myApis.step2",
      "helpCenter.myApis.step3",
      "helpCenter.myApis.step4",
      "helpCenter.myApis.step5"
    ],
    noteKeys: ["helpCenter.myApis.note1"],
    path: "/my-apis"
  },
  {
    id: "get-token",
    titleKey: "helpCenter.getToken.title",
    overviewKey: "helpCenter.getToken.overview",
    featureKeys: [
      "helpCenter.getToken.feature1",
      "helpCenter.getToken.feature2",
      "helpCenter.getToken.feature3"
    ],
    stepKeys: [
      "helpCenter.getToken.step1",
      "helpCenter.getToken.step2",
      "helpCenter.getToken.step3",
      "helpCenter.getToken.step4",
      "helpCenter.getToken.step5"
    ],
    noteKeys: ["helpCenter.getToken.note1", "helpCenter.getToken.note2"],
    path: "/gettoken"
  },
  {
    id: "subscription",
    titleKey: "helpCenter.subscription.title",
    overviewKey: "helpCenter.subscription.overview",
    featureKeys: [
      "helpCenter.subscription.feature1",
      "helpCenter.subscription.feature2",
      "helpCenter.subscription.feature3"
    ],
    stepKeys: [
      "helpCenter.subscription.step1",
      "helpCenter.subscription.step2",
      "helpCenter.subscription.step3",
      "helpCenter.subscription.step4"
    ],
    noteKeys: ["helpCenter.subscription.note1", "helpCenter.subscription.note2"],
    path: "/subscription"
  }
];
